// Duplicado manual de drapp-la/domain (`src/web-routes.ts`) — el paquete
// todavía no tiene pipeline de publish (sin registry configurado, ver
// UI_REFACTOR_PLAN.md §10), así que por ahora esto se sincroniza a mano. Si
// cambia el manifest allá, replicarlo acá.
//
// Rutas REALES de drmanager (con el segmento "events") que ya están
// cubiertas por drapp-la/web — crece por milestone, hoy solo agenda/
// calendario. Regla dura: si una ruta no matchea, drmanager NUNCA redirige
// a un usuario opt-in ahí, aunque el flag esté prendido (UI_REFACTOR_PLAN.md
// §7).
export const WEB_ROUTES = [/^\/teams\/[^/]+\/events\/(agenda|calendar)(\/|$)/]

export function isWebRoute(path) {
  return WEB_ROUTES.some((route) => route.test(path))
}

// path de drmanager -> path equivalente en web (esquema propio, más corto).
// Solo se llama si isWebRoute() ya dio true.
export function mapToWebPath(path) {
  const match = path.match(/^\/teams\/([^/]+)\/events\/(agenda|calendar)(\/|$)/)
  if (!match) return null
  return `/teams/${match[1]}/agenda`
}

// A dónde manda el CTA del banner cuando el usuario NO está parado en una
// ruta cubierta — nunca al path actual en ese caso (UI_REFACTOR_PLAN.md §7).
export function webHomePath(teamId) {
  const bareId = teamId.startsWith('teams/') ? teamId.slice('teams/'.length) : teamId
  return `/teams/${bareId}/agenda`
}
